import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import routes from './routes.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import AnalyticsPlugin from './plugins/analytics'

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Vue2TouchEvents from 'vue2-touch-events'


// --------------------------------
// Cookies
// --------------------------------
import VueCookies from 'vue-cookies'
import cookies from "./modules/cookies/cookieController";

// --------------------------------
// Lazy load image
// --------------------------------
import lazyLoad from './modules/lazyload';
Vue.directive('lazyload', lazyLoad);

// --------------------------------
// Google Analytics
// --------------------------------
// const VueAnalytics = require('vue-analytics');
import 'katex/dist/katex.min.css'


// --------------------------------
// Vue Router
// --------------------------------
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', // web
  // base: process.env.BASE_URL,
  // mode: 'hash', // SI ES MOVIL
  //mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.query.from === 'home' || from.query.from === 'home') {
      return savedPosition || { x: 0, y: 0 }; // Mantenim la posició actual
    }
    return savedPosition || { x: 0, y: 0 }; // Comportament per defecte
  }
})

// printSiteMap(routes, 'https://sele.ai');


router.beforeEach((to, from, next) => {
  // Redirect if fullPath begins with a hash (ignore hashes later in path)
  if (to.fullPath.substr(0, 2) === "/#") {
    const path = to.fullPath.substr(2);
    next(path);
    return;
  }
  next();
});

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader



// --------------------------------
// Vue Meta
// --------------------------------
Vue.use(VueMeta, {
  // keyName: 'metaInfo',
  // attribute: 'data-vue-meta',
  // ssrAttribute: 'data-vue-meta-server-rendered',
  // tagIDKeyName: 'vmid',
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

// --------------------------------
// Axios
// --------------------------------
Vue.use(VueAxios, axios)
axios.defaults.baseURL = process.env.VUE_APP_AXIOS_URI


// --------------------------------
// Google analytics
// --------------------------------

// Vue.use(VueAnalytics, {
//   id: 'G-46KND078WR',
//   router
// })


Vue.use(Toast, {
  position: 'bottom-right',
  duration: 3000
});


Vue.component('my-component', {})


Vue.use(VueCookies);

Vue.use(Vue2TouchEvents)


// Configurar el tema per defecte basat en les cookies o preferència del sistema
const darkMode = Vue.prototype.$cookies.get('darkMode') || window.matchMedia('(prefers-color-scheme: dark)').matches
Vue.prototype.$cookies.config('7d', '', '', true)

// --------------------------------
// PostHog - Session Recording
// --------------------------------
if (process.env.NODE_ENV !== 'development') {
  console.log('Analytics plugin inicializado');
  Vue.use(AnalyticsPlugin)
}

const app = new Vue({
  data() {
    return {
      currentUser: null,
      token: null,
      cart: 0,
      showCaptcha: false,
      isSele: false,    // isSele: true --> sele.ai, false --> sele.ai
      // currentLanguage: Vue.$cookies.get('language') || 'es',
      currentLanguage: 'es',
      // isDark: darkMode, // Afegim l'estat del tema fosc
      // isDark: false, // Afegim l'estat del tema fosc
      isDark: true,
      selectedCommunity: null
    }
  },
  vuetify,
  router,
  template: '',
  render: h => h(App),
  async mounted() {
    document.dispatchEvent(new Event('x-app-rendered'));
    await cookies.user.setInitialValues();
    cookies.token.setInitialValues();
    this.currentUser = cookies.user;
    this.token = cookies.token;
    const cartCookie = Vue.prototype.$cookies.get("cart")
    this.cart = 0;
    if (cartCookie && Object.keys(cartCookie)) {
      Object.values(cartCookie).forEach(v => this.cart += v)
    } else {
      Vue.prototype.$cookies.set("cart", {})
    }
    await cookies.user.setValues(cookies.user);
  },
  computed: {
  }
}).$mount('#app')


// function printSiteMap(routes, pre) {
//   routes.forEach((route) => {
//     const path = `${pre}${route.path}`;
//
//     if (route.path !== '*') {
//       console.log(path)
//     }
//
//     if (route.children) {
//       printSiteMap(route.children, `${path}/`);
//     }
//
//   }, []);
//
// }

